export const NV04_SNAPSHOT_GET = 'NV04_SNAPSHOT_GET';
export const NV04_SNAPSHOT_SUCCESS = 'NV04_SNAPSHOT_SUCCESS';
export const NV04_SNAPSHOT_FAILURE = 'NV04_SNAPSHOT_FAILURE';

export const NV04_CLEAR_DATA = 'NV04_CLEAR_DATA';
